import { Permission } from '@idc-forms/permissions'
import type { RouteObject } from 'react-router'
import { SEGMENTS } from '@/app/router/routes'
import { ProtectedRoute } from '@/shared/components/protected-route'

/**
 * Motor de flujos — rutas del admin (CRUD de definiciones).
 * Reusa el permiso de configuración del cliente (ReadClientConfig): el motor es, en
 * Fase 1, configuración del portal del cliente.
 */
export const flowsRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute permission={Permission.ReadClientConfig} />,
    children: [
      {
        index: true,
        lazy: {
          Component: () => import('./pages/flows-list.page').then((m) => m.default)
        }
      },
      {
        path: SEGMENTS.actions.new,
        lazy: {
          Component: () => import('./pages/flow-form.page').then((m) => m.default)
        }
      },
      {
        path: ':id',
        lazy: {
          Component: () => import('./pages/flow-form.page').then((m) => m.default)
        }
      }
    ]
  }
]
